import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CurrencyText from "../CurrencyText";
import SelectOptionModal from "../SelectOptionModal";
import { EditSecondaryIcon } from "../../assets/svgs";
import { stringToBoolean } from "../../utils";
import "./styles.scss";

const EditOptionCard = ({ data, onChange, isEditable, isTranslated }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const [showSelectOptionModal, setShowSelectOptionModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleOnClickEdit = (item) => {
    setShowSelectOptionModal(true);
    setSelectedItem(item);
  };

  const handleOnClickBackdrop = () => {
    setShowSelectOptionModal(false);
    setSelectedItem(null);
  };

  const handleOnSelect = (evt) => {
    onChange(evt.target.name, evt.target.value);
    setShowSelectOptionModal(false);
  };

  return (
    <>
      <div className="edit-option-card">
        {data.map((item) => {
          const selectedValue = item.options.find(
            (opt) => opt.value === item.value
          );
          const translatedValue =
            selectedValue && isTranslated
              ? t(`${routeName}.${selectedValue?.label}`)
              : selectedValue?.label;
          return (
            <div key={item.key} className="edit-item-container">
              <div>
                <p className="edit-item-label">
                  {t(`${routeName}.${item.label}`)}
                </p>
                <p className="edit-item-value">
                  <CurrencyText
                    value={translatedValue}
                    skipFormatted={stringToBoolean(item.skipFormatted)}
                  />
                </p>
              </div>
              {isEditable ? (
                <img
                  src={EditSecondaryIcon}
                  alt="edit secondary icon"
                  className="edit-icon"
                  onClick={() => handleOnClickEdit(item)}
                />
              ) : null}
            </div>
          );
        })}
      </div>
      <SelectOptionModal
        name={selectedItem?.key}
        value={selectedItem?.value}
        visible={showSelectOptionModal}
        onClickBackdrop={handleOnClickBackdrop}
        heading={selectedItem?.optionModalHeading}
        options={selectedItem?.options || []}
        onSelect={handleOnSelect}
        isTranslated={isTranslated}
      />
    </>
  );
};

export default EditOptionCard;
